var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "config-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v("\n            " + _vm._s(_vm.title) + "\n            "),
          _c("i", [_vm._v(_vm._s(_vm.rateGroupName))]),
          _c("i", [_vm._v(_vm._s(_vm.customerName))]),
          _c("i", [_vm._v(_vm._s(_vm.driverName))]),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "modal-body" }, [
      _c(
        "div",
        { staticClass: "reattempt-container" },
        [
          _c("form-wrapper", { attrs: { validator: _vm.$v } }, [
            _c(
              "div",
              [
                _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                  _vm._v(
                    "\n                        Number of attempts before charges are created, only applies to failed stops with an item.\n                        "
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v(
                    "\n                        This number will only apply charges and costs to this stop only. Anything prior or after\n                        will have no charges or costs.\n                    "
                  ),
                ]),
                _c(
                  "form-group",
                  {
                    staticClass: "form-group",
                    attrs: {
                      name: "reattemptCharges",
                      label: "Reattempt Charges",
                    },
                  },
                  [
                    _c("md-input", {
                      attrs: { type: "number" },
                      model: {
                        value: _vm.rateConfigurationRule.reattemptCharges,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.rateConfigurationRule,
                            "reattemptCharges",
                            _vm._n($$v)
                          )
                        },
                        expression: "rateConfigurationRule.reattemptCharges",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "form-group",
                  {
                    staticClass: "form-group",
                    attrs: { name: "reattemptCosts", label: "Reattempt Costs" },
                  },
                  [
                    _c("md-input", {
                      attrs: { type: "number" },
                      model: {
                        value: _vm.rateConfigurationRule.reattemptCosts,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.rateConfigurationRule,
                            "reattemptCosts",
                            _vm._n($$v)
                          )
                        },
                        expression: "rateConfigurationRule.reattemptCosts",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "equivalence-container" }, [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v("\n                Weight Equivalence\n            "),
        ]),
        _c(
          "div",
          [
            _c(
              "form-group",
              {
                staticClass: "equivalence-item",
                attrs: { name: "weightEquivalence" },
              },
              [
                _c("md-input", {
                  staticClass: "equivalence-number",
                  attrs: { type: "number" },
                  model: {
                    value: _vm.rateConfigurationRule.weightEquivalence,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.rateConfigurationRule,
                        "weightEquivalence",
                        _vm._n($$v)
                      )
                    },
                    expression: "rateConfigurationRule.weightEquivalence",
                  },
                }),
                _c("div", { staticClass: "equivalence-symbol" }, [
                  _vm._v(_vm._s(_vm.teamWeightSymbol.symbol)),
                ]),
              ],
              1
            ),
            _c("md-icon", { staticClass: "scale" }, [
              _vm._v("\n                    scale\n                "),
            ]),
            _c("div", { staticClass: "equivalence-item equivalence-volume" }, [
              _c("div", { staticClass: "equivalence-symbol" }, [
                _vm._v("1 " + _vm._s(_vm.teamVolumeSymbol.symbol)),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "equivalence-container volume-equivalence-container" },
        [
          _c("h4", { staticClass: "modal-title" }, [
            _vm._v("\n                Volume Equivalence\n            "),
          ]),
          _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
            _vm._v(
              "\n                Converts actual weight into an equivalent volume for cubic charges. Cubic charges are calculated on\n                the larger of (actual weight ÷ this value) and the actual volume.\n                "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n                Leave empty to charge cubic on the actual volume. Independent of Weight Equivalence.\n            "
            ),
          ]),
          _c(
            "div",
            [
              _c(
                "form-group",
                {
                  staticClass: "equivalence-item",
                  attrs: { name: "volumeEquivalence" },
                },
                [
                  _c("md-input", {
                    staticClass: "equivalence-number",
                    attrs: { type: "number" },
                    model: {
                      value: _vm.rateConfigurationRule.volumeEquivalence,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.rateConfigurationRule,
                          "volumeEquivalence",
                          _vm._n($$v)
                        )
                      },
                      expression: "rateConfigurationRule.volumeEquivalence",
                    },
                  }),
                  _c("div", { staticClass: "equivalence-symbol" }, [
                    _vm._v(_vm._s(_vm.teamWeightSymbol.symbol)),
                  ]),
                ],
                1
              ),
              _c("md-icon", { staticClass: "scale" }, [
                _vm._v("\n                    scale\n                "),
              ]),
              _c(
                "div",
                { staticClass: "equivalence-item equivalence-volume" },
                [
                  _c("div", { staticClass: "equivalence-symbol" }, [
                    _vm._v("1 " + _vm._s(_vm.teamVolumeSymbol.symbol)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "distance-calculation-container" }, [
        _c(
          "div",
          { staticClass: "distance-checkbox" },
          [
            _c(
              "md-checkbox",
              {
                staticClass: "exact-route",
                model: {
                  value: _vm.rateConfigurationRule.useExactRoute,
                  callback: function ($$v) {
                    _vm.$set(_vm.rateConfigurationRule, "useExactRoute", $$v)
                  },
                  expression: "rateConfigurationRule.useExactRoute",
                },
              },
              [
                _c("md-icon", [_vm._v("route")]),
                _vm._v("\n                    Exact Route\n                "),
              ],
              1
            ),
            _c(
              "md-checkbox",
              {
                staticClass: "straight-line",
                model: {
                  value: _vm.rateConfigurationRule.useStraightLine,
                  callback: function ($$v) {
                    _vm.$set(_vm.rateConfigurationRule, "useStraightLine", $$v)
                  },
                  expression: "rateConfigurationRule.useStraightLine",
                },
              },
              [
                _c("md-icon", [_vm._v("north_east")]),
                _vm._v("\n                    Straight Line\n                "),
              ],
              1
            ),
            _vm._m(0),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "save-container" },
        [
          _c(
            "md-button",
            {
              staticClass: "dialog-button md-primary",
              on: { click: _vm.save },
            },
            [_vm._v("\n                Save\n            ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "distance-text" }, [
      _vm._v(
        "\n                    *Determines how the distance is calculated in rates engine, by default\n                    "
      ),
      _c("b", [_vm._v("Exact Route")]),
      _vm._v(
        "\n                    will be used unless specified.\n                "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }